<script lang="ts">
	import Monthselection from "./Monthselection.svelte";
	import Pharmacy from "./Pharmacy.svelte";
	import PharmacyAwait from "./PharmacyAwait.svelte"
	import Calendar from "./Calendar.svelte";
	import {
		createEventDispatcher
	} from "svelte";
import { object_without_properties } from "svelte/internal";

	const dispatcher = createEventDispatcher()

	let dateObj = new Date();

	let monthName = dateObj.toLocaleDateString("default", {
		month: "long"
	})
	let currentMonthNumber = dateObj.getMonth()
	let currentYearNumber = dateObj.getFullYear()
	let currentDayNumber = dateObj.getDate()
	let selectedDayNumber = currentDayNumber
	let selectedYearNumber = currentYearNumber
	let selectedMonthNumber = currentMonthNumber
	let promise
	let pharmacy
	let date = String(selectedDayNumber) + ".0" + String(selectedMonthNumber) + "." + String(selectedYearNumber)

	function getWeeksStartAndEndInMonth(month, year, startString = "monday") {
		let weeks = [],
			firstDate = new Date(year, month, 1),
			lastDate = new Date(year, month + 1, 0),
			numDays = lastDate.getDate();

		let start = 1;
		let end = 7 - firstDate.getDay();
		if (startString === 'monday') {
			if (firstDate.getDay() === 0) {
				end = 1;
			} else {
				end = 7 - firstDate.getDay() + 1;
			}
		}
		while (start <= numDays) {
			weeks.push({
				start: start,
				end: end
			});
			start = end + 1;
			end = end + 7;
			end = start === 1 && end === 8 ? 1 : end;
			if (end > numDays) {
				end = numDays;
			}
		}

		weeks.forEach(week => {
			let i = week.start
			week.dates = []
			while (i <= week.end) {
				week.dates.push(i);
				i += 1;
			}
		});

		return weeks;
	}

	let weeks = getWeeksStartAndEndInMonth(currentMonthNumber, currentYearNumber)

	function backMonth(e) {
		selectedMonthNumber = e.detail.monthNumber
		if (selectedMonthNumber < 0) {
			selectedYearNumber -= 1
			selectedMonthNumber = 11
		}
		monthName = new Date(selectedYearNumber, selectedMonthNumber).toLocaleDateString("default", {
			month: "long"
		})
		weeks = getWeeksStartAndEndInMonth(selectedMonthNumber, selectedYearNumber)
		if (selectedMonthNumber !== currentMonthNumber || selectedYearNumber !== currentYearNumber) {
			currentDayNumber = null
			selectedDayNumber = null
		} else {
			if (selectedMonthNumber == currentMonthNumber || selectedYearNumber == currentYearNumber) {
				currentDayNumber = dateObj.getDate()
				selectedDayNumber = currentDayNumber
			}
		}
	}

	function forwardMonth(e) {
		selectedMonthNumber = e.detail.monthNumber
		if (selectedMonthNumber > 11) {
			selectedYearNumber += 1
			selectedMonthNumber = 0
		}
		monthName = new Date(selectedYearNumber, selectedMonthNumber).toLocaleDateString("default", {
			month: "long"
		})
		weeks = getWeeksStartAndEndInMonth(selectedMonthNumber, selectedYearNumber)
		if (selectedMonthNumber !== currentMonthNumber || selectedYearNumber !== currentYearNumber) {
			currentDayNumber = null
			selectedDayNumber = null
		} else {
			if (selectedMonthNumber == currentMonthNumber || selectedYearNumber == currentYearNumber) {
				currentDayNumber = dateObj.getDate()
				selectedDayNumber = currentDayNumber
			}
		}
	}

	const selectDay = (e) => {
		if (selectedYearNumber === currentYearNumber) {
			selectedDayNumber = Number(e.detail.day)
			buildDate()
			promise = fetchJson(date)
		}

	}

	function buildDate(){
		if (selectedMonthNumber + 1 < 10) {
			if (selectedDayNumber < 10) {
				date = "0" + String(selectedDayNumber) + ".0" + String(selectedMonthNumber + 1) + "." + String(
					selectedYearNumber)
			} else {
				date = String(selectedDayNumber) + ".0" + String(selectedMonthNumber + 1) + "." + String(
					selectedYearNumber)
			}
		} else {
			if (selectedDayNumber < 10) {
				date = "0" + String(selectedDayNumber) + "." + String(selectedMonthNumber + 1) + "." + String(
					selectedYearNumber)
			} else {
				date = String(selectedDayNumber) + "." + String(selectedMonthNumber + 1) + "." + String(
					selectedYearNumber)
			}
		}
	}

	async function fetchJson(date: string) {
		let res = await fetch("/pharmacy/getByDate/" + date);
		let data = await res.json();
		if(Object.hasOwn(data, "data")){
			pharmacy = data.data
		}else{
			pharmacy = undefined
		}
	}

	buildDate()
	promise = fetchJson(date)
</script>
<div class="flex justify-center mt-6">
	{#if currentYearNumber === selectedYearNumber}
		{#await promise}
			{#if pharmacy != undefined}
				<PharmacyAwait large={false}/>
			{/if}
		{:then}
			<Pharmacy pharmacy={pharmacy} date={date} large={false}/>
		{/await}
	{:else}
	<PharmacyAwait large={false} />
	{/if}
	<div class="flex justify-content ml-16 border-2 rounded shadow-xl p-3">
		<div class="select-none w-96">
			<Monthselection yearNumber={selectedYearNumber} monthName={monthName} monthNumber={selectedMonthNumber} on:backMonth="{backMonth}" on:forwardMonth="{forwardMonth}"/>
			<div class="grid grid-cols-7 p-1 shadow divide-x divide-gray-200 mb-3">
				<div class="flex p-1 justify-center">
					Mo
				</div>
				<div class="flex p-1 justify-center">
					Di
				</div>
				<div class="flex p-1 justify-center">
					Mi
				</div>
				<div class="flex p-1 justify-center">
					Do
				</div>
				<div class="flex p-1 justify-center">
					Fr
				</div>
				<div class="flex p-1 justify-center">
					Sa
				</div>
				<div class="flex p-1 justify-center">
					So
				</div>
			</div>
			<Calendar weeks={weeks} selectedMonthNumber={selectedMonthNumber} selectedYearNumber={selectedYearNumber} currentDayNumber={currentDayNumber} selectedDayNumber={selectedDayNumber} on:selectDay={selectDay}/>
		</div>
	</div>
</div>